import { TextAreaEditDropdown } from "./TextAreaEditDropdown";
import { useToast } from "hooks/useToast";
import { useCallback } from "react";
import { useUpdateTaskAssigneeAdminMutation } from "store/apis/serviceTeam";
import { Task1120Tracker } from "types/Models/TaskTracker";

export const OnHoldReasonColumn = ({ row }: { row: Task1120Tracker }) => {
  const [updateTaskAssignee, { isLoading }] =
    useUpdateTaskAssigneeAdminMutation();
  const { alertToast, successToast } = useToast();
  const inputValue = row.on_hold_reason ?? "";

  const handleSave = useCallback(
    async (value: string) => {
      try {
        await updateTaskAssignee({
          taskId: row.task_uuid,
          on_hold_reason: value || null,
        }).unwrap();
        successToast({ message: "On hold reason updated" });
      } catch (error: any) {
        alertToast({ message: error?.data?.error?.message });
      }
    },
    [row.task_uuid, updateTaskAssignee, successToast, alertToast]
  );

  return (
    <TextAreaEditDropdown
      title="On Hold Reason"
      fieldName="on_hold_reason"
      initialValue={inputValue}
      placeholder="Add on hold reason..."
      isLoading={isLoading}
      onSave={handleSave}
    />
  );
};
